import resources from '../resource.js';

const resource = 'platform';

export default {
    index() {
        return resources.get(`${resource}`);
    },
}
